export enum DELIVERY_TARIFFS {
	FOOT = 'FOOT',
	CAR = 'CAR'
}

export enum TARIFF_TRANSLATES {
	FOOT = 'tariff.foot',
	CAR = 'tariff.car'
}
